module.exports = __webpack_public_path__ + "fonts/NimbusSansDOT-BlacExte.8a640dc.otf";